export default __webpack_public_path__ + "static/media/rnr-sports-table-1-cn.06f94dcd.webp";